import { useState, useRef, ReactElement } from 'react';
import Textarea from '../Textarea/Textarea';
import MarkdownToolbar, { applyMarkdown, MarkdownAction } from '../MarkdownToolbar/MarkdownToolbar';

interface EditableInputProps {
  text?: string | undefined,
  onChangeHandler: (updatedText: string) => void;
  inputStyle?: string;
  active?: boolean;
  notActiveComponent?: (value?: string) => ReactElement<any, any>;
  maxLength?: number;
  ariaLabel?: string;
  markdownToolbar?: boolean;
  rows?: number;
}

const EditableInput = ({ text, onChangeHandler, inputStyle, active, notActiveComponent, maxLength, ariaLabel, markdownToolbar, rows }: EditableInputProps) => {
  const [textValue, setTextValue] = useState<string>(text && text ? text : '');
  const wrapperRef = useRef<HTMLDivElement>(null);
  function onUnFocus() {
    onChangeHandler(textValue);
  }

  function onUpdate(updatedValue: string) {
    setTextValue(updatedValue);
    onChangeHandler(updatedValue);
  }

  function onMarkdownAction(action: MarkdownAction) {
    const textarea = wrapperRef.current?.querySelector('textarea');
    if (!textarea) return;

    const edit = applyMarkdown(action, textValue, textarea.selectionStart, textarea.selectionEnd);
    onUpdate(edit.value);
    requestAnimationFrame(() => {
      textarea.focus();
      textarea.setSelectionRange(edit.selectionStart, edit.selectionEnd);
    });
  }

  const textarea = (
    <Textarea
      className={`${inputStyle} border-lightGray leading-snug`}
      value={textValue}
      onBlur={onUnFocus}
      onChange={e => onUpdate(e.target.value)}
      maxLength={maxLength}
      ariaLabel={ariaLabel}
      rows={rows}
    />
  );

  return (
    (active || !notActiveComponent)
      ? (
        markdownToolbar
          ? (
            <div ref={wrapperRef} className="w-full">
              <MarkdownToolbar onAction={onMarkdownAction} />
              {textarea}
            </div>
          )
          : textarea
      )
      : notActiveComponent(text)
  );
};

export default EditableInput;
